// extracted by mini-css-extract-plugin
export default {"stepFeatures":"customerJourneyVisualizationStepFeaturesInfo_stepFeatures__PaL2u","stepFeaturesDetails":"customerJourneyVisualizationStepFeaturesInfo_stepFeaturesDetails__jeujP"};